import EmployeeDashboardWrapper from "components/layouts/EmployeeDashboardWrapper"
import DefBreadcrumb from "components/ui/breadcrumb/DefBreadcrumb"
import Typography from "components/ui/typography"
import { getCMSSegments } from "utils/helper"
import CategoryQuestionList from "components/cms/Course/CategoryQuestionList"

const CourseCategoryQuestionManagement = () => {
    const segments = getCMSSegments()

    return (
        <EmployeeDashboardWrapper>
            <DefBreadcrumb
                segments={segments}
                prefix="cms"
            />
            <div className="inline-flex items-center">
                <Typography
                    variant="subheading4"
                    as="h1"
                    className="text-primary mt-4"
                >
                    Daftar Kategori Pertanyaan
                </Typography>

            </div>
            <CategoryQuestionList />
        </EmployeeDashboardWrapper>
    )
}

export default CourseCategoryQuestionManagement
